import React, { Component } from "react";
import { Link } from "react-router-dom";

class MenuSection extends Component {
  render() {
    const subMenuItems = this.props.menuItem.subMenuItems || [];

    return (
      <nav className="menu-section col-6">
        <Link className="section-header" to={this.props.menuItem.link}>
          <svg
            className="icon"
            dangerouslySetInnerHTML={{ __html: this.props.menuItem.icon }}
          />
          <span>{this.props.menuItem.title}</span>
        </Link>

        <div className="section-body">
          {subMenuItems.map(value => (
            <div className="section" key={value.id}>
              <Link
                key={value.id}
                className={value.subMenuItems ? "main-item" : "sub-item"}
                to={value.link}
                title={value.title}
              >
                {value.title}
              </Link>
              {value.subMenuItems
                ? value.subMenuItems.map(lastItems => (
                    <Link
                      className="sub-item"
                      key={lastItems.id}
                      to={lastItems.link}
                      title={lastItems.title}
                    >
                      {lastItems.title}
                    </Link>
                  ))
                : ""}
            </div>
          ))}
        </div>
      </nav>
    );
  }
}

export default MenuSection;
